import Marquee from "react-fast-marquee";

const ITEMS = [
    "PAINTKING",
    "CROWN THE COLOR",
    "SOUTH FLORIDA",
    "561 · 698 · 4044",
    "PAUL'S CREW",
    "NO DRIP · NO DRAMA",
];

/**
 * Slow editorial marquee — massive outline text as a section separator.
 * Used between major sections.
 */
export default function EditorialMarquee({
    speed = 22,
    filled = false,
    testId = "marquee",
}) {
    return (
        <div
            data-testid={testId}
            className="relative border-y border-white/10 py-6 md:py-8 bg-black overflow-hidden"
        >
            <Marquee gradient={false} speed={speed} pauseOnHover={false}>
                {ITEMS.map((label, i) => (
                    <span
                        key={`${label}-${i}`}
                        className="inline-flex items-center gap-10 mr-10"
                    >
                        <span
                            className={`font-display uppercase text-6xl md:text-8xl leading-none tracking-tight ${
                                filled ? "text-white" : "outline-text"
                            }`}
                        >
                            {label}
                        </span>
                        <span className="inline-block w-4 h-4 rainbow-bg" />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
